import { Stack, type SxProps } from '@mui/material';
import { type ReactNode, useId } from 'react';

import Title from '../Title';

interface Props {
  title?: ReactNode;
  stretched?: boolean;
  dense?: boolean;

  sx?: SxProps;
  children: ReactNode;
}

export default function FormSection({ title, dense, stretched, sx, children }: Props) {
  const titleId = useId();

  return (
    <Stack
      spacing={dense ? 1 : 2}
      component="section"
      aria-labelledby={titleId}
      sx={[
        {
          maxWidth: stretched ? undefined : 1200,
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {title && (
        <Title
          size="sm"
          component="h2"
          id={titleId}
        >
          {title}
        </Title>
      )}
      {children}
    </Stack>
  );
}
